module.exports = __webpack_public_path__ + "static/image/logo-family/logo_store@2x.png?29d72c8f";